import { CSSObject } from '@chakra-ui/react';

export const FooterMoreOpenText: CSSObject = {
  color: 'delta.600',
};

export const BoxMoreText: CSSObject = {
  w: '8',
};

export const DeductionsText: CSSObject = {
  color: 'gray.400',
  fontSize: '2xs',
  fontWeight: 'normal',
};

export const toteMultiGrid: CSSObject = {
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '6',
  display: 'grid',
};

export const toteMultiGridText: CSSObject = {
  fontSize: 'xs',
  w: 'full',
  color: 'alpha.900',
  mb: '2',
  '&.raceNumber': {
    borderBottom: '1px dashed',
    color: 'alpha.900',
    fontWeight: 'bold',
    borderColor: '#00000040',
    boxShadow: '0px 1px 0px 0px #FFFFFF1A',
  },
};

export const ToteMultiGridText: CSSObject = {
  color: 'alpha.900',
};
